import {Model} from "@vuex-orm/core";

export default class MediaLibraryItemMediaLibraryTag extends Model {
    static entity = 'mediaLibraryItemMediaLibraryTag'

    static primaryKey = ['media_library_item_id', 'media_library_tag_id']

    static fields () {
        return {
            media_library_item_id: this.attr(null),
            media_library_tag_id: this.attr(null)
        }
    }
}
